import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'video_mng',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '地域预警管理',
        addFunName: 'areaWarnAdd',
        modifyFunName: 'areaWarnModify',
        queryFunName: 'areaWarnQuery',
        detailFunName: 'areaWarnDetail',
        delFunName: 'areaWarnDel',
        dicTreeFunName: 'dictionaryCache'
      },
      searchForm: {
        page: 1,
        limit: 10,
        videoName: null,
        sortField: 'create_time',
        labId: localStorage.getItem('accountCategory') === 'Business' ? localStorage.getItem('labId') : null
      },
      formData: {},
      rules: {
        diseasesId: [{
          required: true,
          message: '请选择疾病',
          trigger: 'blur'
        }],
        geoLng: [{
          required: true,
          message: '请选择经纬度',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择企业',
          trigger: 'blur'
        }],
        caseCount: [{
          required: true,
          message: '请输入患病数量',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {},
      disease_show: false,
      lab_show: false,
      dicData: {
        typeUpperCode: 'Fishery_Breed_Type',
        configTypes: [],
        configTypeOptions: {},
        diseasesUpperCode: 'Fishery_Diseases_Type',
        configDiseases: [],
        configDiseasesOptions: {}
      },
      isBusiness: localStorage.getItem('accountCategory') === 'Business'
      // 百度地图
      ,
      markLocation: {},
      mapCenter: {
        lng: 116.413384,
        lat: 39.910925
      },
      inputValue: '',
      searchObj: ''
    };
  },
  components: {
    diseaseSel: function diseaseSel() {
      return import('./disease_sel');
    },
    labSel: function labSel() {
      return import('../org/lab_sel.vue');
    }
  },
  mounted: function mounted() {
    var _this = this;
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.typeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configTypes = res.data;
          var _iterator = _createForOfIteratorHelper(res.data),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              _this.dicData.configTypeOptions[item.code] = item.name;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.diseasesUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configDiseases = res.data;
          var _iterator2 = _createForOfIteratorHelper(res.data),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              _this.dicData.configDiseasesOptions[item.code] = item.name;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.emptyFormData = JSON.parse(JSON.stringify(_this.formData));
      _this.query();
    });
  },
  watch: {
    searchObj: function searchObj(e) {
      var _this2 = this;
      // console.log('searchObj',e)
      if (e) {
        this.inputValue = '';
        this.myGeo = new BMap.Geocoder(); // 创建地址解析器的实例
        this.myGeo.getPoint(e, function (point) {
          console.log('point', point);
          if (point) {
            _this2.mapCenter = _this2.markLocation = point;
            _this2.$set(_this2.formData, 'geoLat', point.lat);
            _this2.$set(_this2.formData, 'geoLng', point.lng);
            // map.centerAndZoom(point, 16);
            // map.addOverlay(new BMapGL.Marker(point, {title: e}))
          } else {
            alert('您选择的地址没有解析到结果！');
          }
        });
      }
    },
    editDialogShow: function editDialogShow(to) {
      if (!to) {
        this.mapCenter = {};
        this.markLocation = {};
      }
    }
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (this.isBusiness && !this.formData.id) {
        this.$set(this.formData, 'labName', localStorage.getItem('labName'));
        this.$set(this.formData, 'labId', localStorage.getItem('labId'));
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.initFormData(this.emptyFormData);
      this.mapCenter = {
        lng: 116.413384,
        lat: 39.910925
      };
      this.markLocation = {};
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(data) {
      if (data.geoLat && data.geoLng) {
        this.mapCenter = {
          lat: data.geoLat,
          lng: data.geoLng
        };
        this.markLocation = {
          lat: data.geoLat,
          lng: data.geoLng
        };
      }
      this.initFormData(data);
      this.editDialogTitle = this.pageConfig.editPageName + '维护';
      this.editDialogShow = true;
    },
    getLocation: function getLocation(e) {
      this.markLocation = e.point;
      this.$set(this.formData, 'geoLat', e.point.lat);
      this.$set(this.formData, 'geoLng', e.point.lng);
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
      }
      this.lab_show = false;
    },
    diseaseClick: function diseaseClick() {
      this.disease_show = true;
    },
    diseaseSel: function diseaseSel(val) {
      if (val) {
        this.$set(this.formData, 'diseasesId', val.id);
        this.$set(this.formData, 'diseasesName', val.name);
      }
      this.disease_show = false;
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this5 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this5.formData.id) {
            _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('编辑成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('编辑失败');
              }
            });
          } else {
            _this5.$api[_this5.pageConfig.addFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('新增成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};